import '@fortawesome/fontawesome-free/css/all.css'

import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'

import router from './router'
import { store } from './store/store';
import velocity from 'velocity-animate'
import Notifications from 'vue-notification'

Vue.config.productionTip = false

Vue.use(Notifications, { velocity })

new Vue({
    router,
    store,
    iconfont: 'fa',
    render: h => h(App),
}).$mount('#app')